/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerStatusEnum } from './customer-status-enum';

export interface SimpleProfile {
  readonly pnr: string | null;
  readonly d_number: string | null;
  readonly utl: string | null;
  readonly bank_account_number: string | null;
  readonly customer_status: CustomerStatusEnum;
}
export namespace SimpleProfile {}
